// extracted by mini-css-extract-plugin
export default {"cubes":"Landing_cubes__GYJrq","mainContainer":"Landing_mainContainer__JktOr","dark":"Landing_dark__FvLeF","mainLockup":"Landing_mainLockup__9eswg","animate":"Landing_animate__WDhM6"};